import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { TituloSubtituloCorFundoContainerService } from './titulo-subtitulo-cor-fundo-container.service';
import { TituloSubtituloCorFundoData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-titulo-subtitulo-cor-fundo-container',
  template: `
    <fcp-titulo-subtitulo-cor-fundo
      [tituloSubtituloCorFundo]="data | async"
    ></fcp-titulo-subtitulo-cor-fundo>
  `
})
export class TituloSubtituloCorFundoContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<TituloSubtituloCorFundoData>;
  constructor(private tituloSubtituloCorFundoContainerService: TituloSubtituloCorFundoContainerService) {}

  ngOnInit() {
    this.data = this.tituloSubtituloCorFundoContainerService.getTituloSubtituloCorFundo(this.id);
  }
}
